import _typeof from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/typeof";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.object.assign";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import Cookies from 'js-cookie'; // cookie保存的天数

import config from '@/config';
import { forEach, hasOneOf, objEqual } from '@/libs/tools';
import routes from "../router";
var title = config.title,
    cookieExpires = config.cookieExpires,
    useI18n = config.useI18n;
export var TOKEN_KEY = 'token';
import Vue from 'vue';
import routersArr from '../router/routers'; //本地路由

export var setToken = function setToken(token) {
  Cookies.set(TOKEN_KEY, token, {
    expires: cookieExpires || 1
  });
};
export var getToken = function getToken() {
  var token = Cookies.get(TOKEN_KEY);
  if (token) return token;else return false;
};
export var hasChild = function hasChild(item) {
  return item.children && item.children.length !== 0;
};

var showThisMenuEle = function showThisMenuEle(item, access) {
  if (item.meta && item.meta.access && item.meta.access.length) {
    if (hasOneOf(item.meta.access, access)) return true;else return false;
  } else return true;
};
/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */


export var getMenuByRouter = function getMenuByRouter(list, access) {
  var res = [];
  forEach(list, function (item) {
    if (!item.meta || item.meta && !item.meta.hideInMenu) {
      var obj = {
        icon: item.meta && item.meta.icon || '',
        name: item.name,
        meta: item.meta
      };

      if ((hasChild(item) || item.meta && item.meta.showAlways) && showThisMenuEle(item, access)) {
        obj.children = getMenuByRouter(item.children, access);
      }

      if (item.meta && item.meta.href) obj.href = item.meta.href;
      if (showThisMenuEle(item, access)) res.push(obj);
    }
  });
  return res;
};
/**
 * 根据role 获取本地的菜单权限
 * @param roleRoule 角色配置的路由
 * @param routList 所有的路由列表
 */

export var getMenuByRouterRole = function getMenuByRouterRole(roleRoule, routList) {
  var res = getRole(roleRoule, routList);
  return res;
};
export var getRole = function getRole(roleRoule, routList) {
  var res = [];
  var temp;

  for (var i in roleRoule) {
    var list = roleRoule[i]; //权限菜单的路由是否在routList中

    var getresult = getRouteInRole(list, routList);

    if (getresult) {
      var itemObj = _objectSpread({}, getresult);

      itemObj.children = []; //写入功能权限

      if (list.hasOwnProperty('apilist')) {
        var apiList = [];

        for (var j in list.apilist) {
          var api = list.apilist[j];

          if (api.res_name && api.checked) {
            apiList.push(api.res_name);
          }
        }

        var apiRole = localStorage.getItem('apiRole');

        if (apiRole) {
          var obj = JSON.parse(apiRole);
          obj[list.route] = apiList;
          localStorage.setItem('apiRole', JSON.stringify(obj));
        } else {
          var _obj = _defineProperty({}, list.route, apiList);

          localStorage.setItem('apiRole', JSON.stringify(_obj));
        }
      }

      res.push(itemObj);

      if (list.children_menu && list.children_menu.length > 0) {
        temp = getRole(list.children_menu, routList);

        if (temp.length > 0) {
          itemObj.children = temp;
        }
      }

      if (getresult.children && getresult.children.length > 0) {
        for (var _i = 0; _i < getresult.children.length; _i++) {
          var glist = getresult.children[_i];

          if (glist.meta.hideInMenu) {
            itemObj.children.push(glist);
          }
        }
      }
    }
  }

  return res;
};
export var getRouteInRole = function getRouteInRole(targetObj, routList) {
  var item;

  var getRoute = function getRoute(arr) {
    for (var i in arr) {
      var list = arr[i];

      if (list.path === targetObj.route || list.path === targetObj.route && list.meta.hideInMenu === true) {
        item = list; //获取菜单中，保存的title

        item.meta.title = targetObj.menu_name;
        item.title = targetObj.menu_name;
        break;
      } else {
        if (list.children && list.children.length > 0) {
          getRoute(list.children);
        }
      }
    }
  };

  getRoute(routList);
  return item;
};
/**
 * 通过路由列表得到菜单列表
 * @param list 获取的菜单
 * @param sources 本地路由
 * @param access 权限
 * @returns {Array}
 */

export var getMenuByLocalRouter = function getMenuByLocalRouter(list, sources, access) {
  var res = [];
  forEach(list, function (item) {
    for (var i = 0; i < sources.length; i++) {
      var inner = sources[i];

      if (item.url == inner.path) {
        var obj = Object.assign({}, inner); //查看item 是否有child

        if (item.hasOwnProperty("secondLevelMenu") && item.secondLevelMenu != null && item.secondLevelMenu.length > 0) {
          obj.children = getMenuByLocalChildRouter(item.secondLevelMenu, inner.children, access);
        }

        res.push(obj);
      }
    }
  });
  console.log("result");
  console.log(res);
  (Vue.prototype.__share_pool__ = Vue.prototype.__share_pool__ || {}).routes = routes;

  for (var i = 0; i < routersArr.length; i++) {
    if (routersArr[i].name == '_home') {
      var _routersArr$i$childre;

      (_routersArr$i$childre = routersArr[i].children).push.apply(_routersArr$i$childre, res);
    }
  }

  Vue.prototype.__share_pool__.routes.addRoutes(routersArr.concat([{
    path: "*",
    redirect: "/404"
  }]));

  return res;
};
export var getMenuByLocalChildRouter = function getMenuByLocalChildRouter(list, sources, access) {
  var res = [];
  forEach(list, function (item) {
    for (var i = 0; i < sources.length; i++) {
      var inner = sources[i];

      if (item.url == inner.path) {
        var obj = Object.assign({}, inner);
        res.push(obj);
      }
    }
  });
  return res;
};
/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */

export var getBreadCrumbList = function getBreadCrumbList(route, homeRoute) {
  // let homeItem = { ...homeRoute, icon: homeRoute.meta.icon }
  var routeMetched = route.matched; // if (routeMetched.some(item => item.name === homeRoute.name)) return [homeItem]

  var res = routeMetched.filter(function (item) {
    return item.meta === undefined || !item.meta.hideInBread;
  }).map(function (item) {
    var meta = _objectSpread({}, item.meta);

    if (meta.title && typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true;
      meta.title = meta.title(route);
    }

    var obj = {
      icon: item.meta && item.meta.icon || '',
      name: item.name,
      meta: meta
    };

    if (item.name === 'projectManage') {
      obj.title = route.params.name;
      obj.meta.title = route.params.name;
    }

    return obj;
  });
  res = res.filter(function (item) {
    return !item.meta.hideInMenu || !item.meta.hideInBread;
  }); //去掉首页的显示

  return _toConsumableArray(res); //return [{...homeItem, to: homeRoute.path}, ...res]
};
export var getRouteTitleHandled = function getRouteTitleHandled(route) {
  var router = _objectSpread({}, route);

  var meta = _objectSpread({}, route.meta);

  var title = '';

  if (meta.title) {
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true;
      title = meta.title(router);
    } else title = meta.title;
  }

  meta.title = title;
  router.meta = meta;
  return router;
};
export var showTitle = function showTitle(item, vm) {
  var _item$meta = item.meta,
      title = _item$meta.title,
      __titleIsFunction__ = _item$meta.__titleIsFunction__,
      getName = _item$meta.getName;
  if (!title) return;

  if (useI18n) {
    if (title.includes('{{') && title.includes('}}') && useI18n) title = title.replace(/({{[\s\S]+?}})/, function (m, str) {
      return str.replace(/{{([\s\S]*)}}/, function (m, _) {
        return vm.$t(_.trim());
      });
    });else if (__titleIsFunction__) title = item.meta.title;else title = vm.$t(item.name);
  } else title = item.meta && item.meta.title || item.name;
  /**
   * 需要添加到title上时
   */


  if (getName) {
    return item.params.name;
  }

  return title;
};
/**
 * @description 本地存储和获取标签导航列表
 */

export var setTagNavListInLocalstorage = function setTagNavListInLocalstorage(list) {
  sessionStorage.tagNaveList = JSON.stringify(list);
};
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */

export var getTagNavListFromLocalstorage = function getTagNavListFromLocalstorage() {
  var list = sessionStorage.tagNaveList;
  return list ? JSON.parse(list) : [];
};
/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */

export var getHomeRoute = function getHomeRoute(routers) {
  var homeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'home';
  var i = -1;
  var len = routers.length;
  var homeRoute = {};

  while (++i < len) {
    var item = routers[i];

    if (item.children && item.children.length) {
      var res = getHomeRoute(item.children, homeName);
      if (res.name) return res;
    } else {
      if (item.name === homeName) homeRoute = item;
    }
  }

  return homeRoute;
};
/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */

export var getNewTagList = function getNewTagList(list, newRoute) {
  var name = newRoute.name,
      path = newRoute.path,
      meta = newRoute.meta;

  var newList = _toConsumableArray(list);

  if (newList.findIndex(function (item) {
    return item.name === name;
  }) >= 0) return newList;else newList.push({
    name: name,
    path: path,
    meta: meta
  });
  return newList;
};
/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */

var hasAccess = function hasAccess(access, route) {
  if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access);else return true;
};
/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */


export var canTurnTo = function canTurnTo(name, access, routes) {
  var routePermissionJudge = function routePermissionJudge(list) {
    return list.some(function (item) {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children);
      } else if (item.name === name) {
        return hasAccess(access, item);
      }
    });
  };

  return routePermissionJudge(routes);
};
/**
 * @param {String} url
 * @description 从URL中解析参数
 */

export var getParams = function getParams(url) {
  var keyValueArr = url.split('?')[1].split('&');
  var paramObj = {};
  keyValueArr.forEach(function (item) {
    var keyValue = item.split('=');
    paramObj[keyValue[0]] = keyValue[1];
  });
  return paramObj;
};
/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */

export var getNextRoute = function getNextRoute(list, route) {
  var res = {};

  if (list.length === 2) {
    res = getHomeRoute(list);
  } else {
    var index = list.findIndex(function (item) {
      return routeEqual(item, route);
    });
    if (index === list.length - 1) res = list[list.length - 2];else res = list[index + 1];
  }

  return res;
};
/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */

export var doCustomTimes = function doCustomTimes(times, callback) {
  var i = -1;

  while (++i < times) {
    callback(i);
  }
};
/**
 * @param {Object} file 从上传组件得到的文件对象
 * @returns {Promise} resolve参数是解析后的二维数组
 * @description 从Csv文件中解析出表格，解析成二维数组
 */

export var getArrayFromFile = function getArrayFromFile(file) {
  var nameSplit = file.name.split('.');
  var format = nameSplit[nameSplit.length - 1];
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsText(file); // 以文本格式读取

    var arr = [];

    reader.onload = function (evt) {
      var data = evt.target.result; // 读到的数据

      var pasteData = data.trim();
      arr = pasteData.split(/[\n\u0085\u2028\u2029]|\r\n?/g).map(function (row) {
        return row.split('\t');
      }).map(function (item) {
        return item[0].split(',');
      });
      if (format === 'csv') resolve(arr);else reject(new Error('[Format Error]:你上传的不是Csv文件'));
    };
  });
};
/**
 * @param {Array} array 表格数据二维数组
 * @returns {Object} { columns, tableData }
 * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在iView的表格中展示数据
 */

export var getTableDataFromArray = function getTableDataFromArray(array) {
  var columns = [];
  var tableData = [];

  if (array.length > 1) {
    var titles = array.shift();
    columns = titles.map(function (item) {
      return {
        title: item,
        key: item
      };
    });
    tableData = array.map(function (item) {
      var res = {};
      item.forEach(function (col, i) {
        res[titles[i]] = col;
      });
      return res;
    });
  }

  return {
    columns: columns,
    tableData: tableData
  };
};
export var findNodeUpper = function findNodeUpper(ele, tag) {
  if (ele.parentNode) {
    if (ele.parentNode.tagName === tag.toUpperCase()) {
      return ele.parentNode;
    } else {
      return findNodeUpper(ele.parentNode, tag);
    }
  }
};
export var findNodeUpperByClasses = function findNodeUpperByClasses(ele, classes) {
  var parentNode = ele.parentNode;

  if (parentNode) {
    var classList = parentNode.classList;

    if (classList && classes.every(function (className) {
      return classList.contains(className);
    })) {
      return parentNode;
    } else {
      return findNodeUpperByClasses(parentNode, classes);
    }
  }
};
export var findNodeDownward = function findNodeDownward(ele, tag) {
  var tagName = tag.toUpperCase();

  if (ele.childNodes.length) {
    var i = -1;
    var len = ele.childNodes.length;

    while (++i < len) {
      var child = ele.childNodes[i];
      if (child.tagName === tagName) return child;else return findNodeDownward(child, tag);
    }
  }
};
export var showByAccess = function showByAccess(access, canViewAccess) {
  return hasOneOf(canViewAccess, access);
};
/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */

export var routeEqual = function routeEqual(route1, route2) {
  var params1 = route1.params || {};
  var params2 = route2.params || {};
  var query1 = route1.query || {};
  var query2 = route2.query || {};
  return route1.name === route2.name && objEqual(params1, params2) && objEqual(query1, query2);
};
/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */

export var routeHasExist = function routeHasExist(tagNavList, routeItem) {
  var len = tagNavList.length;
  var res = false;
  doCustomTimes(len, function (index) {
    if (routeEqual(tagNavList[index], routeItem)) res = true;
  });
  return res;
};
export var localSave = function localSave(key, value) {
  localStorage.setItem(key, value);
};
export var localRead = function localRead(key) {
  return localStorage.getItem(key) || '';
}; // scrollTop animation

export var scrollTop = function scrollTop(el) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments.length > 2 ? arguments[2] : undefined;
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var endCallback = arguments.length > 4 ? arguments[4] : undefined;

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }

  var difference = Math.abs(from - to);
  var step = Math.ceil(difference / duration * 50);

  var scroll = function scroll(start, end, step) {
    if (start === end) {
      endCallback && endCallback();
      return;
    }

    var d = start + step > end ? end : start + step;

    if (start > end) {
      d = start - step < end ? end : start - step;
    }

    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }

    window.requestAnimationFrame(function () {
      return scroll(d, end, step);
    });
  };

  scroll(from, to, step);
};
/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */

export var setTitle = function setTitle(routeItem, vm, titleobj) {
  var handledRoute = getRouteTitleHandled(routeItem);
  var pageTitle = showTitle(handledRoute, vm);
  var resTitle = pageTitle ? "".concat(titleobj, " - ").concat(pageTitle) : title;
  window.document.title = resTitle;
};
/**
 * 获取距离当天的时间 年-月-日
 * @param dayCount
 * @returns {string}
 */

export var getDateToCurrent = function getDateToCurrent(dayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + dayCount); //获取daycount的天数

  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; //获取当前月份的日期

  var d = dd.getDate();

  if (m >= 0 && m <= 9) {
    m = '0' + m;
  }

  if (d >= 0 && d <= 9) {
    d = '0' + d;
  }

  return y + "-" + m + "-" + d;
};
/**
 * 时间戳转年月日
 */

export var formatYMD = function formatYMD(shijianchuo) {
  var time = new Date(shijianchuo);
  console.log("time", time);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '-' + m + '-' + d;
};
/**
 *时间戳转年月日时分秒
 * @param {*} shijianchuo 
 * @returns 
 */

export var formatYMDHMS = function formatYMDHMS(shijianchuo) {
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
};
/**
 * 获取距离当天时间的年月日 时分秒
 * @param dayCount
 */

export var traversingTree = function traversingTree(data, id) {
  var result = [],
      temp = [];

  for (var i in data) {
    var list = data[i];

    if (list.parentDept == id) {
      var item = {};
      item.label = list.deptName;
      item.value = list.deptId;
      result.push(item);
      temp = traversingTree(data, list.deptId);

      if (temp.length > 0) {
        item.children = temp;
      }
    }
  }

  return result;
};
/**
 * 根据用的code显示用户操作权限
 * @param arr
 * @param code
 */

export var showUserOperWithCodeRegExp = function showUserOperWithCodeRegExp(arr, code) {
  var result = false;
  var str = eval(code);
  var reg = new RegExp(str, '');

  if (arr && arr.length > 0) {
    for (var i = 0; i < arr.length; i++) {
      if (reg.test(arr[i].roleCode)) {
        result = true;
        break;
      }
    }
  }

  return result;
};
/**
 *显示用户角色
 * @param arr
 * @param code
 * @returns {string}
 */

export var showSolesWithCodeRegExp = function showSolesWithCodeRegExp(arr, code) {
  var result = '';
  var str = eval(code);
  var reg = new RegExp(str, '');

  if (arr && arr.length > 0) {
    for (var i = 0; i < arr.length; i++) {
      if (reg.test(arr[i].roleCode)) {
        result = arr[i].roleCode;
        break;
      }
    }
  }

  return result;
};
/**
 * 请求回调工厂
 * @param successCallBack
 * @param errorCallback
 * @returns {Function}
 */

export var callbackFactory = function callbackFactory(successCallBack, errorCallback) {
  return function (res) {
    if (0 === res.status) {
      if (typeof successCallBack === "function") {
        successCallBack(res);
      }
    } else {
      console.error(res.message);

      if (typeof errorCallback === "function") {
        errorCallback(res.message);
      }
    }
  };
};
export var getDeptTreeData = function getDeptTreeData(data) {
  var arr = [];

  for (var i in data) {
    var obj = {
      value: data[i].deptID,
      label: data[i].deptName
    };

    if (data[i].childDept && data[i].childDept != null && data[i].childDept.length > 0) {
      obj.children = getDeptTreeData(data[i].childDept);
    }

    arr.push(obj);
  }

  return arr;
};
/**
 * 根据path遍历整个路由
 * @param path
 * @param routes
 */

export var getRouteWithPath = function getRouteWithPath(path, routes) {
  var obj = {};
  var p = path.split("/");

  if (p.length >= 3) {
    for (var i = 0; i < routes.length; i++) {
      var list = routes[i];

      if (list.path === '/' + p[1]) {
        var temp = {};
        Object.assign(temp, list);
        obj = temp;
        obj.children = [];

        if (list.children && list.children.length > 0) {
          for (var j = 0; j < list.children.length; j++) {
            var item = list.children[j];
            console.log(p[2] + "" + item.path);

            if (p[2] == item.path) {
              obj.children.push(item);
            }
          }
        }
      }
    }
  }

  return obj;
};
/**
 * 获取时间之差的天数
 * @param startTime
 * @param endTime
 * @returns {number}
 */

export var getTimeDays = function getTimeDays(startTime, endTime) {
  var s = new Date(startTime);
  var e = new Date(endTime);
  var d = e.getTime() - s.getTime();
  return parseInt(d / (1000 * 60 * 60 * 24));
}; // 深拷贝

export var deepcopy = function deepcopy(source) {
  if (!source) {
    return source;
  }

  var sourceCopy = source instanceof Array ? [] : {};

  for (var item in source) {
    sourceCopy[item] = _typeof(source[item]) === 'object' ? deepcopy(source[item]) : source[item];
  }

  return sourceCopy;
};
/**
 * 封装接口返回
 * @param res
 * @param success
 * @param fail
 */

export var reqCallback = function reqCallback(res, success, fail) {
  if (res.result === 0) {
    success && success();
  } else {
    fail && fail();
  }
};
/**
 * 根据时间差返回天时分秒
 * @param inputTime
 * @returns {Array}
 */

export var getTimeDiff = function getTimeDiff(inputTime) {
  var result = [];
  var targetTime = new Date(inputTime).getTime();
  var current = new Date().getTime();
  var diff = current - targetTime; //得到时间差
  //计算出相差天数

  var days = Math.floor(diff / (24 * 3600 * 1000));

  if (days > 1) {
    var gettemp = new Date(inputTime);
    var timeOut = gettemp.getFullYear() + '年' + (gettemp.getMonth() + 1) + '月' + gettemp.getDate() + '日';
    result.push({
      value: timeOut,
      label: ''
    });
  } else {
    result.push({
      value: 0,
      label: '天'
    });
  } //计算出小时数


  var leave1 = diff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数

  var hours = Math.floor(leave1 / (3600 * 1000));
  result.push({
    value: hours,
    label: '小时前'
  }); //计算相差分钟数

  var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数

  var minutes = Math.floor(leave2 / (60 * 1000));
  result.push({
    value: minutes,
    label: '分钟前'
  }); //计算相差秒数

  var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数

  var seconds = Math.round(leave3 / 1000);
  result.push({
    value: seconds,
    label: '秒前'
  });
  return result;
};
/**
 * 递归菜单列表
 * @param data
 */

export var recursiveMenu = function recursiveMenu(data) {
  var res = [];
  var temp;

  for (var i in data) {
    var list = data[i];

    if (list.parent_id === 0) {
      if (list.hasOwnProperty("checked")) {
        delete list.checked;
      }
    }

    var item = {
      menu_desc: list.menu_desc,
      sort_order: list.sort_order,
      route: list.route,
      api_codes: list.api_codes,
      category: list.category,
      apilist: list.apilist,
      code: list.code,
      id: list.id,
      menu_name: list.menu_name,
      parent_code: list.parent_code,
      title: list.menu_name,
      expand: true
    };

    if (list.children_menu && list.children_menu.length === 0) {
      item.checked = list.checked === 1;
    }

    item.children = [];
    res.push(item);

    if (list.children_menu && list.children_menu.length > 0) {
      temp = recursiveMenu(list.children_menu);

      if (temp.length > 0) {
        item.children = temp;
      }
    }
  }

  return res;
};
/**
 * 获取当前的年月日时分秒
 * @returns 
 */

export var getcurrTime = function getcurrTime() {
  var d = new Date();
  var m = d.getMonth() + 1;
  var day = d.getDate();
  var h = d.getHours();
  var min = d.getMinutes();
  var s = d.getSeconds();

  if (m < 10) {
    m = '0' + m;
  }

  if (day < 10) {
    day = '0' + day;
  }

  if (h < 10) {
    h = '0' + h;
  }

  if (min < 10) {
    min = '0' + min;
  }

  if (s < 10) {
    s = '0' + s;
  }

  var o = {
    "Y": d.getFullYear(),
    "M": m,
    // 月份
    "d": day,
    // 日
    "time": h + ':' + min + ':' + s // 小时

  };
  return o;
};
/**
* 获取当前的年月日
* @returns 
*/

export var getcurrDate = function getcurrDate() {
  var d = new Date();
  var m = d.getMonth() + 1;
  var day = d.getDate();

  if (m < 10) {
    m = '0' + m;
  }

  if (day < 10) {
    day = '0' + day;
  }

  var year = d.getFullYear();
  var o = year + "-" + m + "-" + day;
  return o;
};
/**
 * 根据时获取前后的时间
 * @param {*} date 
 * @param {*} dayCount 
 * @returns 
 */

export var getDateToResult = function getDateToResult(date, dayCount) {
  var dd = new Date(date);
  dd.setDate(dd.getDate() + dayCount); //获取daycount的天数

  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; //获取当前月份的日期

  var d = dd.getDate();

  if (m >= 0 && m <= 9) {
    m = '0' + m;
  }

  if (d >= 0 && d <= 9) {
    d = '0' + d;
  }

  return y + "-" + m + "-" + d;
};
/**
 * 获取前面2个月
 * @param {*} date 
 * @param {*} dayCount 
 * @returns 
 */

export var getDateTobefore = function getDateTobefore(date, num) {
  var dd = new Date(date); //dd.setDate(dd.getDate() + dayCount);//获取daycount的天数

  var y = dd.getFullYear();
  var m = dd.getMonth() + num; //获取当前月份的日期

  var d = dd.getDate();

  if (m >= 0 && m <= 9) {
    m = '0' + m;
  }

  if (d >= 0 && d <= 9) {
    d = '0' + d;
  }

  return y + "-" + m;
};
/**
 * 获取当前月份 年-月
 * @param dayCount
 * @returns {string}
 */

export var getMonthToCurrent = function getMonthToCurrent(dayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + dayCount); //获取daycount的天数

  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; //获取当前月份的日期

  var d = dd.getDate();

  if (m >= 0 && m <= 9) {
    m = '0' + m;
  }

  return y + "-" + m;
};